import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { TimeWarningLog } from 'types';

export const getTimeWarningLog = async ({
  fromDate,
  toDate,
  analyzerId,
}: {
  fromDate: string;
  toDate: string;
  analyzerId: number;
}): Promise<TimeWarningLog[]> => {
  const query =
    analyzerId && analyzerId !== -1
      ? {
          params: {
            fromDate,
            toDate,
            analyzerId,
          },
        }
      : {
          params: {
            fromDate,
            toDate,
          },
        };

  const { data } = await axios.get('/api/time-warning-log', query);
  return data as TimeWarningLog[];
};

type QueryFnType = typeof getTimeWarningLog;

type UseTimeWarningLogOptions = {
  config?: QueryConfig<QueryFnType>;
  fromDate: string;
  toDate: string;
  analyzerId: number;
};

export const useTimeWarningLog = ({
  fromDate,
  toDate,
  analyzerId,
  config,
}: UseTimeWarningLogOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['timeWarningLog', fromDate, toDate, analyzerId],
    queryFn: () => getTimeWarningLog({ fromDate, toDate, analyzerId }),
  });
};
